module.exports = __webpack_public_path__ + "1dafdc7bb69227ccc046f6b04b1ac077.jpg";